"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getContentIdsOfContent(content) {
    try {
        const modelType = content.modelType;
        switch (modelType) {
            case 'offer':
                let contentIds = [];
                for (const childContent of content.children) {
                    const childContentIds = getContentIdsOfContent(childContent);
                    contentIds = [...contentIds, ...childContentIds];
                }
                return [...contentIds, content._id];
            case 'curriculumOffer':
            case 'activity':
            case 'channelCard':
                return [content._id];
            default:
                console.info('Incorrect modelType found in getContentByContentId', modelType);
        }
        return [];
    }
    catch (error) {
        throw new Error('Error in getContentIdsOfContent ' + error);
    }
}
exports.getContentIdsOfContent = getContentIdsOfContent;
//# sourceMappingURL=getContentIdsOfContent.js.map